import Image from "next/image"
import Head from "next/head";
import upscbanner1 from "../../assets/images/home/Mob_Banner/Achivers-2026-Web-Banner.jpg";
// import upscbanner2 from "../../assets/images/home/Mob_Banner/Banner.png";
import sadhana from "../../assets/images/upsc/sadhanaL-2.png";
import { useEffect, useState } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
// import phone from "../../assets/images/upsc/phone.png";
import Carousel from 'react-bootstrap/Carousel';
import downloadicon from "../../assets/images/download.png";
import redrightarrow from  "../../assets/images/contact/Rarrow.png";
import Success from "../../assets/images/home/newicon/Success.jpg";
import Target1 from "../../assets/images/home/newicon/target.jpg";
import Faculty from "../../assets/images/home/newicon/Faculty.jpg";
import TestSeries from "../../assets/images/home/newicon/Testseries.jpg";
import styles from "./upsc-ias-ips-admission.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import NPFform from"../../components/NPFForm/npfform"
import dynamic from "next/dynamic";
import NewiconA from "../../assets/images/header/modalnew.png";
import CountUp from "react-countup";
import star from "../../assets/images/about/why-shankar-ias-academy/trainers.webp";
import meet from "../../assets/images/about/why-shankar-ias-academy/inter.webp";
import worl from "../../assets/images/about/why-shankar-ias-academy/infra.webp";
import guidance from "../../assets/images/about/why-shankar-ias-academy/test.webp";
import mentor from "../../assets/images/about/why-shankar-ias-academy/interview.webp";
import test from "../../assets/images/about/why-shankar-ias-academy/test series.webp";
const ObtionalButton = dynamic(()=>import("../../components/optionalbutton"));
const Interest = dynamic(()=>import("../../components/might-be-interest"));
const Acheiver = dynamic(()=>import("../../components/our-acheiver/achievers"));
const BranchAddress = dynamic(()=>import("../../components/branch-address"), { ssr: false });
import Program_Features from "./upsc-ias-ips-admission-program-features";
//import Classroom_form from "./upsc-ias-ips-admission-form";
import Link from "next/link";
import { useRouter } from "next/router";
import useDownloader from "react-use-downloader";
import Emioption from "../../components/Service/emioption";
import Optionalplus from "../../components/Service/optionalplus";
import { Target } from "lucide-react";
const UPSCClassroomOnline = () => {
  
  const {download} = useDownloader();
  const fileUrl = "/pdf/admission/SIA-Brochure-2025-Annanagar.pdf";
  const filename = "SIA-Brochure-2025-Annanaga.pdf"

  const feestructure =[
    {date:"16.02.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    {date:"25.03.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    {date:"31.03.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    {date:(<><div>23.04.2026</div> <div><span style={{fontSize:"11px"}}>(*Subject to change<br/> based on the election date)</span></div> </>) ,  cont:"Regular",cont1:"08:00 am to 10:30 am"},
    {date:"16.05.2026", cont:"Weekend", cont1:"02:00 pm to 07:30 pm"},
    {date:"04.06.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    {date:"04.06.2026", cont:"Regular", cont1:"11:00 am to 01:30 pm"},
    {date:"24.06.2026", cont:"Regular", cont1:"11:00 am to 01:30 pm"},

  ]

  const feestructure2 =[
  
    {date:"06.04.2026",cont:"Regular",cont1:"02.30 pm to 04.30 pm"},
    {date:"18.06.2026",cont:"Regular",cont1:"02.30 pm to 04.30 pm"},
    {date:"18.06.2026",cont:"Regular",cont1:"05.30 pm to 07.30 pm"},
    {date:"27.06.2026",cont:"Weekend",cont1:"09:00 am to 01:00 pm"},
    
  ]

  const feestructure3 =[

    {date:"05.07.2026",cont:"Weekend",cont1:"History",cont2:"09:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Geography",cont2:"09:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Psychology",cont2:"09:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Tamil literature",cont2:"09:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Mathematics",cont2:"08:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Economics",cont2:"09:00 am to 01:00 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Public Administration",cont2:"02:30 pm to 05:00 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"PSIR",cont2:"02:30 pm to 05:00 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Sociology",cont2:"05:00 pm to 07:30 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Anthropology",cont2:"02:30 pm to 04:30 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Agriculture",cont2:"06:30 pm to 08:30 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"English",cont2:"02:30 pm to 05:00 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Law",cont2:"02:30 pm to 05:00 pm"}
   
  ]

   const banners = [
      { img: upscbanner1, alt: "UPSC Anna Nagar", link: "/upsc-admission-anna-nagar"},
      // { img: upscbanner2, alt: "UPSC Anna Nagar", link: "/upsc-admission-anna-nagar"},
  
    ]

  const stats = [
    { value: 2900, suffix: "+", label: "IAS, IPS & IFS Selections", delay: 100 },
    { value: 202, label: "of 958 | UPSC CSE 2025", delay: 200 },
    { value: 9, label: "Govt Partnerships", delay: 300 },
  ];
  

  const jsonLd ={
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Best UPSC Academy in India | Shankar IAS Academy",
    "url": "https://www.shankariasacademy.com/upsc-admission-anna-nagar/",
    "Image":
    "https://www.shankariasacademy.com/_next/static/media/Pre-book-2024_Webbanner-Without-button.6686241b.webp",
    "description": "Join Shankar IAS Academy, the best IAS academy in India, for expert UPSC coaching, quality study material, and proven strategies to crack the IAS exam."
  }


const router = useRouter();

useEffect(() => {
  AOS.init({
    duration: 800,
    easing: "ease-in-out",
    once: true,
    offset: 100,
  });
}, []);

useEffect(() => {
  const handleRouteChange = () => {
    AOS.refresh();
  };

  router.events.on("routeChangeComplete", handleRouteChange);

  return () => {
    router.events.off("routeChangeComplete", handleRouteChange);
  };
}, [router.events]);

  
    return (
      <>

        <Head>
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="noindex,nofollow" />
            <meta name="robots" content="noindex, nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>Best UPSC Academy in India | Shankar IAS Academy</title>
            <meta name="title" content="Best UPSC Academy in India | Shankar IAS Academy" />
            <meta name="keywords" content="" />
            <meta name="description" content="Join Shankar IAS Academy, the best IAS academy in India, for expert UPSC coaching, quality study material, and proven strategies to crack the IAS exam." />
            <link rel="canonical" href=" https://www.shankariasacademy.com/upsc-admission-anna-nagar/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Best UPSC Academy in India | Shankar IAS Academy" />
            <meta property="og:description" content="Join Shankar IAS Academy, the best IAS academy in India, for expert UPSC coaching, quality study material, and proven strategies to crack the IAS exam." />
            <meta property="og:url" content=" https://www.shankariasacademy.com/upsc-admission-anna-nagar/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
            {/* <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script> */}
        </Head>

  <Navbar title="upsc" />

  <div className="container">
    <div className="row">
      <div className="col-md-6">
        <div data-aos="fade-right" className= {`${styles.cardBox} d-flex flex-wrap gap-3 p-4`}>
          <h1>UPSC Civil Services Admission Open - 2026</h1>

            <Link href="/upsc-admission-anna-nagar" className= {`${styles.branchBtn} `}>
              Anna Nagar
            </Link>

            <Link href="/adyar" className={`${styles.branchBtn}`}>
              Adyar
            </Link>

            <Link href="/delhi" className={`${styles.branchBtn} `}>
              Delhi
            </Link>

            <Link href="/bengaluru" className={`${styles.branchBtn} `}>
              Bengaluru
            </Link>

            <Link href="/coimbatore" className={`${styles.branchBtn} `}>
              Coimbatore
            </Link>

            <Link href="/hyderabad" className={`${styles.branchBtn} `}>
              Hyderabad
            </Link>

            <Link href="/thiruvananthapuram" className={`${styles.branchBtn} `}>
              Trivandrum
            </Link>

            <Link href="/trichy" className={`${styles.branchBtn} `}>
              Trichy
            </Link>

            <Link href="/salem" className={`${styles.branchBtn} `}>
              Salem
            </Link>

            <Link href="/madurai" className={`${styles.branchBtn} `}>
              Madurai
            </Link>

            <Link href="/upsc-online-class" className={`${styles.branchBtn} `}>
              Online Class
            </Link>

            <Link href="/upsc-admission-nri" className={`${styles.branchBtn} `}>           
              NRI
            </Link>
        </div>

        <div data-aos="fade-left" className={`${styles.bestbg1}`}>
          <div className="p-4">
            <h2 className="text-center"> Pre Booking Open Now</h2> 
            <p>GSPCM will start on 16th February 2026. For pre-booking, contact the number - <span style={{color:'#db1b0d' }}>9003190030</span> </p>
            <div className={`${styles.brochure} justify-content-center`}>
              <a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Brochure-Chennai-Admission-2026.pdf" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.normalbutton1} btn btn-danger`}>
                  <Image src={downloadicon} alt="download icon" /> UPSC GSPCM 2026 (Brochure)
                </button>
              </a>
            </div>
            
          </div>
        </div>
      </div>

      <div className="col-md-6 pt-3">
        <Carousel>
          {banners.map((e, index) =>
            <Carousel.Item key={index}>
              <Link href={e.link} rel="noreferrer">
                <Image
                className="carouselimage w-100 h-100"
                src={e.img}
                alt={e.alt}
                title="Shankar IAS Academy"
                /> 
              </Link>
            </Carousel.Item>
          )}
        </Carousel>
      </div>
    </div>
  </div>       

  {/*<Classroom_form branchname="Annanagar"/> */}

  <div className="container-fluid "  style={{
      background: "linear-gradient(to top, rgba(255, 242, 242, 0.8), rgb(182, 238, 255 , 29%))",
      opacity: "1",
    }}>
    <div className="container">
      <div className= "row mt-4 mb-2 ">
        <div className={`${styles.admincontent} col-12 col-md-6 pt-5 `}>
          <div className={styles.heroCard} data-aos="fade-right">
            <span className={styles.badge}>India's Trusted UPSC Coaching</span>
            <h1 className={styles.title}>
              Best IAS Coaching in India
              <span> Shankar IAS Academy Chennai</span>
            </h1>
            <h2 className={styles.description}>
              Shankar IAS Academy stands as a pioneer in UPSC coaching, earning the reputation of being the Best IAS Academy in India through its consistent <b>track record</b> of producing top-ranking civil servants.
            </h2>
            {/* Stats */}
            <div className={styles.statsRow}>
              {stats.map((item, index) => (
                <div
                  key={index}
                  className={styles.statCircle}
                  data-aos="zoom-in"
                  data-aos-delay={item.delay}
                >
                  <span className={styles.circleGlow}></span>
                  <h3>
                    <CountUp
                      end={item.value}
                      duration={6.5}
                      suffix={item.suffix || ""}
                    />
                  </h3>
                  <p>{item.label}</p>
                </div>
              ))}
            </div>
            {/* Features */}
            <div className={`${styles.featureGrid} pt-3`}>

              <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="400">
              <span><Image src={Success} width="36" height="36" alt="New_icon" className="img-fluid mx-2" /></span>  High Success Rate 
              </div>

              <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="500">
                <span><Image src={Target1} width="46" height="4 6" alt="New_icon" className="img-fluid mx-2" /></span> Prelims & Mains Integrated Coaching
              </div>

              <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="600">
                  <span><Image src={Faculty} width="46" height="46" alt="New_icon" className="img-fluid mx-2" /></span>Expert Faculty & Mentorship
              </div>

              <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="700">
                <span><Image src={TestSeries} width="36" height="36" alt="New_icon" className="img-fluid mx-2" /></span>Advanced Test Series
              </div>

            </div>

            <div  className={`${styles.newachievernumber1} text-end pt-4 d-none d-md-block`} data-aos="fade-up" data-aos-delay="400">
              <Link href="#" className={`${styles.acheivermore}`} id=""  onclick="fbq('track', 'ButtonClick');">
                <span style={{ color: "rgb(66, 60, 60)", fontWeight:"bold", fontSize:"16px" }}>& More</span> <Image src={redrightarrow} className={`${styles.logoimg} img-fluid`} alt="Chennai Icon" width={20} height={20} />
              </Link>
            </div>
          </div>
        </div>
        <div data-aos="fade-left" class="col-12  col-md-6 mt-4 mb-2">
          <p className={`${styles.contactheader} text-center`}>Enquiry</p>
          <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
          {/* <div class={`${styles.addmissionform} npf_wgts `} data-height="600px"   data-w="3f4274baec4df825dd72c5ff92d085ff"> </div>  */}
          <NPFform
            formId="3f4274baec4df825dd72c5ff92d085ff"
            height="600px"
            className="myForm"
          />
        </div>
      </div>
    </div>
  </div>

  {/*Why chose Shankar IAS Academy */}

  <div className={`${styles.whySection} py-5`}>
    <div className="container">

      <div className="text-center mb-5">
        <h2 className={styles.sectionTitle}>
          Why Choose Shankar IAS Academy?
        </h2>
        <p className={styles.sectionDesc}>
          India's trusted institution for UPSC preparation with a structured,
          result-oriented learning ecosystem.
        </p>
      </div>

      <div className="row g-4">

        {/* CARD */}
        <div data-aos="flip-right" data-aos-delay="200"  className="col-lg-4 col-md-6">
          <div className={styles.chooseCard}>
            <div className={styles.iconWrapper}>
              <Image src={star} width={55} height={55} alt="icon" />
            </div>
            <h5>Expert Faculty</h5>
            <p>
              We take pride in our team of highly experienced educators, subject matter experts, and former civil servants who bring years of real-world administrative experience to the classroom. Their expertise helps students develop a deep conceptual understanding and master the art of answer writing.
            </p>
          </div>
        </div>

        <div data-aos="flip-right" data-aos-delay="300" className="col-lg-4 col-md-6">
          <div className={styles.chooseCard}>
            <div className={styles.iconWrapper}>
              <Image src={meet} width={55} height={55} alt="icon" />
            </div>
            <h5>Structured Curriculum</h5>
            <p>
              Our well-structured curriculum covers every aspect of the UPSC syllabus, ensuring that students receive comprehensive guidance for Prelims, Mains, and Interview preparation. We focus on a systematic and topic-wise approach, making complex subjects easier to understand.
            </p>
          </div>
        </div>

        <div data-aos="flip-right" data-aos-delay="400" className="col-lg-4 col-md-6">
          <div className={styles.chooseCard}>
            <div className={styles.iconWrapper}>
              <Image src={worl} width={55} height={55} alt="icon" />
            </div>
            <h5>High Success Rate</h5>
            <p>
              With hundreds of successful candidates clearing the exam for IAS, IPS, IFS and other services every year, we have cemented our reputation as the Best UPSC Coaching in Chennai. Our rigorous training programs and proven teaching methodologies have helped aspirants secure top ranks in the Civil Services Examination.
            </p>
          </div>
        </div>

        <div data-aos="flip-right" data-aos-delay="500" className="col-lg-4 col-md-6">
          <div className={styles.chooseCard}>
            <div className={styles.iconWrapper}>
              <Image src={guidance} width={55} height={55} alt="icon" />
            </div>
            <h5>Study Materials</h5>
            <p>
              We provide regularly updated study materials, notes, and current affairs analysis that are aligned with the latest UPSC trends and exam patterns. Our resources include NCERT-based notes, standard reference books, and exclusive Shankar IAS publications to help students build a strong foundation.
            </p>
          </div>
        </div>

        <div data-aos="flip-right" data-aos-delay="600" className="col-lg-4 col-md-6">
          <div className={styles.chooseCard}>
            <div className={styles.iconWrapper}>
              <Image src={test} width={55} height={55} alt="icon" />
            </div>
            <h5>Mock Tests & Evaluation</h5>
            <p>
            Our full-length mock tests, test series, and daily answer writing practice help students gauge their progress, improve time management, and enhance their problem-solving skills. We provide detailed performance analysis and feedback, enabling aspirants to refine their strategies and address weaknesses effectively.
            </p>
          </div>
        </div>

        <div data-aos="flip-right" data-aos-delay="700" className="col-lg-4 col-md-6">
          <div className={styles.chooseCard}>
            <div className={styles.iconWrapper}>
              <Image src={mentor} width={55} height={55} alt="icon" />
            </div>
            <h5>Personalized Mentorship</h5>
            <p>
              Understanding that every aspirant’s journey is unique, we offer one-on-one mentorship and personalized guidance to help students overcome challenges, improve their weak areas, and build confidence. Our mentors provide motivational support, exam-oriented strategies, and career counseling to ensure students stay focused and achieve their IAS dreams.
            </p>
          </div>
        </div>
        <p className="text-center pt-3"> With our student-centric approach, well-researched study plans, and commitment to excellence, <br/> Shankar IAS Academy continues to be the Best IAS Academy in Chennai, Tamil Nadu, and India, <br/>shaping future civil servants who will lead the nation.</p>
      </div>
    </div>
  </div>

  <div className="container py-4">
    <h5 className={`text-center ${styles.bangmainTitle}`}>Program Features & Benefits</h5>
    <Program_Features />
  </div>

  <div className="container-fluid p-0">
    <div className={`${styles.startegy1}`}>
      <div className="row g-4 ">
        <div className={`${styles.sadhana}`}>
          <div class="container">
            <div className="row">
              <div className="col-12 col-md-4 text-white order-3 order-md-first mt-2 p-2">UPSC GS-Mains Test Series 2025 (Moksha)<br /><a href="/upsc-mains-test-series/" className={`${styles.normalbutton} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`}> Click here <span></span></a></div>
              <div className="col-12 col-md-4 p-2 order-second order-md-second">
                <Link href="/two-year-upsc-program">
                  <Image alt="sadhana" className="img-fluid" src={sadhana} />
                </Link>
              </div>
              <div className="col-12 col-md-4 text-white mt-2 p-2 order-first order-md-last">UPSC GSPCM 2025 (Brochure)<br />
                <button className={`${styles.normalbutton2} ${styles.brochurebtn} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`} onClick={() => download(fileUrl, filename)}>
                  <p className=""> <Image src={downloadicon} alt="download icon" /> Download Brochure</p>
                </button> 
              </div>
            </div>
          </div>
        </div>           
      </div>
    </div>
  </div>

  <section id="courseandfees">
    <div className="container py-5">
      <h2 className={`text-center mb-5 ${styles.mainTitle}`}>Course & Fee Structure – 2026</h2>
      <div className="row g-4">
        {/* ================= GS CARD ================= */}
        <div data-aos="fade-down" className="col-xl-4 col-lg-6 col-12">
          <div  className={`${styles.premiumCard} ${styles.highlightCard} h-100`}>
            <div className={styles.ribbon}>Admission Opening</div>
            <div className={styles.cardTop}>
              <h4>General Studies</h4>
              <p>Preliminary Cum Mains</p>
            </div>
            <div className={styles.priceBox}>
              ₹1,38,000
              <span>Inclusive of GST</span>
            </div>
            <button className={styles.primaryBtn}>Pay Now</button>
            <div className={styles.scheduleSection}>
              {feestructure.map((item, index) => (
                <div key={index} className={styles.scheduleItem}>
                  <div>{item.date}</div>
                  <div>{item.cont}</div>
                  <div>{item.cont1}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ================= CSAT CARD ================= */}
        <div data-aos="fade-up" className="col-xl-4 col-lg-6 col-12">
          <div className={`${styles.premiumCard} h-100`}>
            <div className={styles.cardTop}>
              <h4>CSAT</h4>
            </div>
            <div className={styles.priceBox}>
              ₹12,000
              <span>Inclusive of GST</span>
            </div>
            <button className={styles.primaryBtn}>Pay Now</button>
            <div className={styles.scheduleSection}>
              {feestructure2.map((item, index) => (
                <div key={index} className={styles.scheduleItem}>
                  <div>{item.date}</div>
                  <div>{item.cont}</div>
                  <div>{item.cont1}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ================= OPTIONAL CARD ================= */}
        <div data-aos="fade-down" className="col-xl-4 col-lg-6 col-12">
          <div className={styles.premiumCard}>
            <div className={styles.cardTop}>
              <h4>Optional Subjects</h4>
            </div>

            <div className={styles.priceBox}>
              ₹34,000
            </div>
            <button className={styles.primaryBtn}>Pay Now</button>
            <div className={styles.scheduleSection}>
              {feestructure3.map((item, index) => (
                <div key={index} className={styles.scheduleItem}>
                  <div>{item.cont1}</div>
                  <div>{item.date}</div>
                  <div>{item.cont}</div>
                  <div>{item.cont2}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="col-xl-3 offset-xl-8 col-lg-4 col-md-6 col-8  text-end pb-2 ">
            <ObtionalButton />
        </div>
        
        <div data-aos="zoom-in" className={styles.premiumCard}>
          <div className={`${styles.facultyborder3} row h-100 `}>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <p className={`${styles.sectionsubtitle} mb-0`}>GSPCM+CSAT+Optional</p>
              <p className={`${styles.sectionsubtitle} pb-0`}>Total Amount</p>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <span className={`${styles.acheiverrank}`}> <span className={`${styles.sectionredtitle} `}><b>₹</b>1,84,000*</span><span>(inclusive of tax)</span></span>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-12  text-right">
              <Emioption />                
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-12  text-right pt-xl-0 pt-3">
              <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.normalbutton}`}>Pay Here</button></a>
            </div>

            <p className={`${styles.aboutparagraph1}  p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;Fees are inclusive of GST & SIA study materials.</p>
          </div>
        </div>

        <div className="row">
          <div  className="col-md-12 col-lg-8 col-xl-8 col-12 pt-3 pe-xl-0">
            {/* <p className={`${styles.aboutparagraph1} p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;<b>₹5,000</b> Discount will be applicable for Integrated Course payment <b>(GS + CSAT + Optional)</b></p> */}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4 col-12 pt-3 ps-xl-0">
          </div>
        </div>
      </div>
    </div>
  </section>

  {/* Our Acheivers */}
  <section id="toppers">
    <div className="container">
      <div className="row">
        <div className="col  text-center">
          <h2 className={`${styles.sectiontitle} mb-0`}>Our Achievers</h2>
          <p className={`${styles.sectionsubtitle}`}>
            Rank Holders from our academy
          </p>
        </div>
      </div>
    </div>
  </section>

  <Acheiver />

  <section id="toppers">
    <div className="container">
      <div className="row">
        <div className="col-xl-12 col-lg-6 mb-3 mb-md-4 col-12 ">
          <Optionalplus /> 
        </div>
        <div className={`${styles.oneplusbox}`}>
        </div>
      </div>
    </div>
  </section>

  <section id="courses">
    <div className="container-fluid">
      <div className={`${styles.bestbg}`}>
        <h4 className="text-center">Best IAS Academy in Chennai - Comprehensive UPSC Courses Offered</h4>
        <h6 className="text-center">
          At Shankar IAS Academy, we provide a diverse selection of courses carefully <br/> designed to meet the unique requirements of UPSC aspirants:
        </h6>

        <div className="row g-4 mt-2">
          <div className="col-12 col-md-6 col-lg-12">
            <div className="card shadow-sm p-4">
              <div className="card-icon">
                <i className="fas fa-chalkboard-teacher"></i>
              </div>
              <h5>UPSC Prelims & Mains Coaching</h5>
              <p>
              Our comprehensive Prelims and Mains coaching program is structured to provide in-depth subject coverage, extensive current affairs analysis, and rigorous test series to help aspirants clear both stages with confidence.
              </p>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-12">
            <div className="card shadow-sm p-4">
              <div className="card-icon">
                <i className="fas fa-book"></i>
              </div>
              <h5>Optional Subject Coaching</h5>
              <p>
              Choosing the right optional subject is crucial for securing a top rank in UPSC Mains. We offer specialized coaching for high-scoring and popular optional subjects, including – Sociology, Economics, Geography, Public Administration, Political Science, Anthropology, Tamil Literature, Mathematics, Agriculture and more.
              </p>
            </div>
          </div>
        
          <div className="col-12 col-md-6 col-lg-12">
            <div className="card shadow-sm p-4">
              <div className="card-icon">
                <i className="fas fa-users"></i>
              </div>
              <h5>UPSC Interview Guidance Program</h5>
              <p>
              The Personality Test (Interview) is the final stage of the UPSC selection process, and it requires confidence, presence of mind, and strong communication skills. Our Interview Guidance Program includes:
              </p>
              <ul className="list-group list-group-flush">
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span>One-on-one Mock Interviews conducted by retired civil servants, subject experts, and senior bureaucrats.</li>
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span>MCQ-Based Questions & Current Affairs Discussions to enhance knowledge and spontaneity.</li>
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span>Personality Development Sessions to improve articulation, confidence, and presentation.</li>
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span>Individual Feedback & Performance Analysis to help aspirants refine their approach and maximize their scores.</li>
              </ul>
            </div>
          </div>
        
          <div className="col-12 col-md-6 col-lg-12">
            <div className="card shadow-sm p-4">
              <div className="card-icon">
                <i className="fas fa-book-open"></i>
              </div>
              <h5>NCERT Foundation Course</h5>
              <p>
              A strong foundation is the key to UPSC success. Our NCERT Foundation Course is designed for beginners and undergraduate students who aim to build a solid conceptual base before diving into advanced topics.
              </p>
              <ul className="list-group list-group-flush">
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span> <span style={{fontWeight:'600'}}>Comprehensive NCERT Coverage –</span> Subject-wise detailed explanation of History, Geography, Polity, Economics, and Science & Technology. </li>
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span> <span style={{fontWeight:'600'}}>Basic to Advanced Approach – </span>Simplified teaching methods that gradually introduce complex concepts.</li>
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span><span style={{fontWeight:'600'}}> Answer Writing & Analytical Thinking Development –  </span>Focus on exam-oriented approach and conceptual clarity.</li>  
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
      
    {/* CSAT Program 
      <div className="container pt-3">
          <div className="col-12">
            <div className="csattable">
              <div className="row csathead">
                <div className="col-12 col-lg-2">
                    <p className={`${styles.tableheading1} mb-0`}>CSAT</p>
                </div>
                <div className="col-12 col-lg-4">
                    <p className={`${styles.tablepara1} mb-0`}>27th January 2024<br/>(Weekend	09:00 am to 01:00 pm)</p>
                </div>
                <div className="col-12 col-lg-2">
                    <p className={`${styles.tablepara1} mb-0`}>₹ 22,000</p>
                </div>
                <div className="col-12 col-lg-4">
                    <p  className={`${styles.tablepara1} mb-0`}>Admission - <Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></p>
                </div>
              </div>
            </div>
          </div>
      </div>*/}
      
  {/* Fee Details Section */}


  <section id="courses">
    <div className="container-fluid">
      <div className={`${styles.bestbg}`}>
        <h4 className="text-center pb-2">Best UPSC Coaching in Chennai - Admissions Open</h4>
        <div className="row g-4 mt-4">
          <div className="col-12 col-md-6 col-lg-12">
            <div className="card shadow-sm p-4">
              <p>
              Take the first step toward your IAS dream by joining the <span style={{color:'#e11212'}}> Best IAS Academy in Anna Nagar.</span> With a proven track record of success, expert faculty, and a structured learning approach, Shankar IAS Academy has helped countless aspirants secure top ranks in the UPSC Civil Services Examination. 
              </p>

              <p>
              As the <span style={{color:'#e11212'}}> Best IAS Academy in Tamil Nadu,</span> we are committed to providing high-quality coaching, personalized mentorship, and result-driven strategies to help you excel. 
              </p>

              <p>
              <span style={{color:'#e11212'}}>Admissions are now open - </span>secure your spot and start your journey toward becoming a civil servant today!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>   

    <BranchAddress />
    <Interest />
    <Footer />  

    </>
  )
}
  
  export default UPSCClassroomOnline;
